const styles = theme => ({
	dashboard: {
		position: 'fixed',
		bottom: '16px',
		width: '320px',
		left: 'calc(50% - 160px)',
		background: theme.palette.grey[700],
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	pageNumbers: {
		width: '56px',
		height: '22px',
		marginLeft: '8px',
		fontSize: '12px',
		lineHeight: '22px',

		color: theme.palette.grey[300]
	},
	paging: {
		display: 'flex',
		flexFlow: 'row nowrap',
		marginLeft: '8px'
	},
	'@media (max-width: 512px)': {
		dashboard: {
			left: 0,
			bottom: 0,
			width: '100%',
			borderRadius: 0
		}
	},
	'@media (max-width: 768px)': {
		dashboard: {
			justifyContent: 'space-between'
		}
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer-dashboard/styles.js